import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CheckBoxOptions, ControlLayout, Country, DropdownOptions, EnglishArabicDTO, InputType, MultiLingualTextBoxOptions, PhoneOptions, TextAreaOptions, TextBoxOptions } from 'bnsights-control-library';
import { TemplateService } from '../../shared/Services/TemplateService.service';
import { FormGroup } from '@angular/forms';
import { ClipboardService } from 'ngx-clipboard';
import { SendEmailTemplateModel } from './../../shared/models/NotificationsModels/SendEmailTemplateModel';
import { EmailTemplateTesterModel } from '../../shared/models/NotificationsModels/EmailTemplateTesterModel';
import { SMSTemplateTesterModel } from '../../shared/models/NotificationsModels/SMSTemplateTesterModel';
import { TemplateDTO } from '../../shared/models/NotificationsModels/TemplateDTO';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bnsights-utilities-library';

@Component({
  selector: 'lib-template-info',
  templateUrl: './template-info.component.html'
})
export class TemplateInfoComponent implements OnInit {
  TemplateId: string = ""
  TemplateInfo:any
  Template:any
  ProductionMode: boolean;
  LanguageList:any
  EmailServiceProviderList:any
  SMSServiceProviderList:any
  CategoryList = [];
  TypeList = [];
  OrganizationList = [];
  LanguageModeList = [];
  MasterLayoutList = [];
    //GenerateCode  Model Controls 
    GenerateCodeForm = new FormGroup({});
    IsOpenGenerateCodeModal: boolean;
    GenerateCodeTextArea: TextAreaOptions;
    ValueToCopy: string = "";

    //Send Model Controls
  SendEmailForm = new FormGroup({});
  To: TextAreaOptions;
  EmailServiceProvider : DropdownOptions;
  Language: DropdownOptions;
  IsSendEmailFormLoaded: boolean;
  @ViewChild('CloseSendEmailForm', { static: false }) CloseSendEmailForm: ElementRef;

    //Test Send Model Controls
    TestSendEmailForm = new FormGroup({});
    TestSendEmailTo: TextAreaOptions;
    TestEmailServiceProvider : DropdownOptions;
    IsTestSendEmailFormLoaded: boolean;
    @ViewChild('CloseTestSendEmailForm', { static: false }) CloseTestSendEmailForm: ElementRef;


      //Test Send SMS Model Controls
      TestSendSMSForm = new FormGroup({});
      TestSendSMSTo: PhoneOptions;
      TestSMSServiceProvider : DropdownOptions;
      IsTestSendSMSFormLoaded: boolean;
      @ViewChild('CloseTestSendSMSForm', { static: false }) CloseTestSendSMSForm: ElementRef;
  
      //Edit Model Controls
  EditTemplateForm = new FormGroup({});
  EditMultiLingualName:MultiLingualTextBoxOptions
  EditSysName: TextBoxOptions;
  EditDescriptionInEnglish: TextAreaOptions;
  EditDescriptionInArabic: TextAreaOptions;
  EditOrganization: DropdownOptions;
  EditLanguageMode: DropdownOptions;
  EditCategory: DropdownOptions;
  EditMasterLayout: DropdownOptions;
  IsEditTemplateFormLoaded: boolean;
  EditIsEmail: CheckBoxOptions;
  EditIsSms: CheckBoxOptions;
  EditEnableIntensiveLogging: CheckBoxOptions;
  @ViewChild('CloseEditTemplateModal', { static: false }) CloseEditTemplateModal: ElementRef;
  language:string="";
  constructor(private authService:AuthService, public utilityService:UtilityService,private bbsfTranslateService:BBSFTranslateService,private environmentService:EnvironmentService,private _clipboardService: ClipboardService, private templateService: TemplateService, private activatedRoute: ActivatedRoute, private router: Router, private pageInfoService: PageInfoService, private modalService: NgbModal) {
    this.activatedRoute.params.subscribe(params => {
      this.TemplateId = params['id'];
    });
  }

  async ngOnInit(): Promise<void> {
    this.utilityService.startBlockUI()
    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.language = event.lang;
      this.utilityService.stopBlockUI();
      this.ngOnInit();
    })
    this.language = await this.utilityService.getCurrentLanguage();
    this.ProductionMode = this.environmentService.getProductionMode()

    this.templateService.GetTemplateInfo(Number(this.TemplateId)).subscribe((result)=>{
      let Result:any=result
      this.TemplateInfo=Result.val;
      //this.SubheaderTitle = this.language == "en" ? this.TemplateInfo.emailtemplateinfo.emailSubject.english : this.TemplateInfo.emailtemplateinfo.emailSubject.arabic;
        PageInfoService.PageTitle=this.TemplateInfo.templateName
        PageInfoService.PageBreadcrumbs=[
         {title: this.utilityService.getResourceValue("Home") , path: '/Admin/Home', isSeparator: false, isActive: false},
         {title: '', path: '', isSeparator: true, isActive: false},
         {title: this.utilityService.getResourceValue("Templates"), path: '/Admin/Notifications/Templates', isSeparator: false, isActive: false},
         {title: '', path: '', isSeparator: true, isActive: false}
  
      ];
    this.pageInfoService.calculateTitle();
    this.pageInfoService.calculateBreadcrumbs();
    });

   
    this.templateService.GetSendEmailTemplate().subscribe((result)=>{
      let Result:any=result
      this.EmailServiceProviderList=Result.val.emailProviders;
      this.LanguageList=Result.val.languageKeys;
    });
    this.templateService.GetTestSMSTemplate().subscribe((result)=>{
      let Result:any=result
      this.SMSServiceProviderList=Result.val;
    });
    this.LoadDropdownLists();
  }

  LoadDropdownLists() {
    this.templateService.Loaddropdowns().subscribe((result) => {
      let DropdownLists = result as any
      this.OrganizationList = DropdownLists.organization
      this.CategoryList = DropdownLists.lookUpItemsCategory
      this.TypeList = DropdownLists.types
      this.MasterLayoutList = DropdownLists.emailHeaderAndFooterTemplate
      this.LanguageModeList = DropdownLists.lookUpItemsEmailTemplate
    })
  }

 
 
  copyInputMessage() {
    this._clipboardService.copy(this.ValueToCopy.toString());
  }

  showGenerateCodeByIdModal(template: any, GenerateCodeModal) {
    this.templateService.GenerateCodeById( template.id).subscribe((result) => {
      var Value = result as any
      this.GenerateCodeTextArea = new TextAreaOptions();
      this.GenerateCodeTextArea.Name = "GenerateCodeTextArea";
      this.GenerateCodeTextArea.Value = Value.val.toString();
      this.ValueToCopy = Value.val.toString();
      this.GenerateCodeTextArea.IsDisabled = true;
      this.GenerateCodeTextArea.HideLabel = true;
      this.GenerateCodeTextArea.Rows = 20;
      this.GenerateCodeTextArea.Cols = 20;
      this.GenerateCodeTextArea.MaxLength = 1000000;
      this.modalService.open(GenerateCodeModal);

    }, (error) => {
     
    })
  }
  showGenerateUpdateCodeByIdModal(template: any, GenerateCodeModal) {
    this.GenerateCodeForm = new FormGroup({})

    this.templateService.GenerateUpdateCodeById(template.id).subscribe((result) => {
      var Value = result as any
      this.GenerateCodeTextArea = new TextAreaOptions();
      this.GenerateCodeTextArea.Name = "GenerateCodeTextArea";
      this.GenerateCodeTextArea.Value = Value.val.toString();
      this.ValueToCopy = Value.val.toString();
      this.GenerateCodeTextArea.IsDisabled = true;
      this.GenerateCodeTextArea.HideLabel = true;
      this.GenerateCodeTextArea.Rows = 20;
      this.GenerateCodeTextArea.Cols = 20;
      this.GenerateCodeTextArea.MaxLength = 1000000;
      this.modalService.open(GenerateCodeModal);
    }, (error) => {
      
    })
  }

  showEditTemplateModal(EditTemplateModal) {
    this.EditTemplateForm = new FormGroup({})
    this.templateService.GetTemplateById(Number(this.TemplateId)).subscribe((result)=>{
      let Result:any=result
      this.Template=Result.val;

      this.TemplateId = this.Template.id
  
      let Name=new EnglishArabicDTO();
      Name.Arabic=this.Template.name.arabic;
      Name.English=this.Template.name.english;
  
      this.EditMultiLingualName = new MultiLingualTextBoxOptions();
      this.EditMultiLingualName.Name = "Name";
      this.EditMultiLingualName.ArabicLabelKey = "NameInArabic";
      this.EditMultiLingualName.EnglishLabelKey = "NameInEnglish";
      this.EditMultiLingualName.IsRequired = true;
      this.EditMultiLingualName.Value = Name;

      this.EditSysName = new TextBoxOptions();
      this.EditSysName.Name = "EditSysName";
      this.EditSysName.LabelKey = "SysName";
      this.EditSysName.Type = InputType.Text;
      this.EditSysName.Value = this.Template.sysName;
  
  
      this.EditDescriptionInEnglish = new TextAreaOptions();
      this.EditDescriptionInEnglish.Name = "EditDescriptionInEnglish";
      this.EditDescriptionInEnglish.LabelKey = "DescriptionInEnglish";
      this.EditDescriptionInEnglish.Value = this.Template.description.english;

      this.EditDescriptionInArabic = new TextAreaOptions();
      this.EditDescriptionInArabic.Name = "EditDescriptionInArabic";
      this.EditDescriptionInArabic.LabelKey = "DescriptionInArabic";
      this.EditDescriptionInArabic.Value = this.Template.description.arabic;
  
      this.EditOrganization = new DropdownOptions();
      this.EditOrganization.Name = "EditOrganization"
      this.EditOrganization.LabelKey = "Organization"
      this.EditOrganization.ViewType = ControlLayout.Vertical
      this.EditOrganization.DataSource = this.OrganizationList
      this.EditOrganization.SingleSelection = true;
      this.EditOrganization.AllowSearchFilter = true;
      this.EditOrganization.Placeholder = "";
      this.EditOrganization.IsRequired = true;
      this.EditOrganization.SelectedItems = this.OrganizationList.filter((item) => { return parseInt(item.key) == this.Template.organizationID; }).map((item) => item.key)[0];;
  
  
      this.EditLanguageMode = new DropdownOptions();
      this.EditLanguageMode.Name = "EditLanguageMode"
      this.EditLanguageMode.LabelKey = "LanguageMode"
      this.EditLanguageMode.DataSource = this.LanguageModeList
      this.EditLanguageMode.SingleSelection = true;
      this.EditLanguageMode.AllowSearchFilter = true;
      this.EditLanguageMode.Placeholder = "";
      this.EditLanguageMode.IsRequired = true;
      this.EditLanguageMode.SelectedItems = this.LanguageModeList.filter((item) => { return parseInt(item.key) == this.Template.languageModeItemID; }).map((item) => item.key)[0];;
  
  
      this.EditMasterLayout = new DropdownOptions();
      this.EditMasterLayout.Name = "EditMasterLayout"
      this.EditMasterLayout.LabelKey = "MasterLayout"
      this.EditMasterLayout.DataSource = this.MasterLayoutList
      this.EditMasterLayout.SingleSelection = true;
      this.EditMasterLayout.AllowSearchFilter = true;
      this.EditMasterLayout.Placeholder = "";
      this.EditMasterLayout.IsRequired = true;
      this.EditMasterLayout.SelectedItems = this.MasterLayoutList.filter((item) => { return parseInt(item.key) == this.Template.emailHeaderAndFooterTemplateID; }).map((item) => item.key)[0];;
  
  
      this.EditCategory = new DropdownOptions();
      this.EditCategory.Name = "EditCategory"
      this.EditCategory.LabelKey = "Category"
      this.EditCategory.DataSource = this.CategoryList
      this.EditCategory.SingleSelection = true;
      this.EditCategory.AllowSearchFilter = true;
      this.EditCategory.Placeholder = "";
      this.EditCategory.IsRequired = true;
      this.EditCategory.SelectedItems = this.CategoryList.filter((item) => { return parseInt(item.key) == this.Template.categoryItemID; }).map((item) => item.key)[0];;
  
  
      this.EditIsEmail = new CheckBoxOptions();
      this.EditIsEmail.Name = "EditIsEmail"
      this.EditIsEmail.LabelKey = "IsEmail"
      this.EditIsEmail.Value = this.Template.isEmail
  
  
      this.EditIsSms = new CheckBoxOptions();
      this.EditIsSms.Name = "EditIsSms"
      this.EditIsSms.LabelKey = "IsSms"
      this.EditIsSms.Value = this.Template.isSms
  
  
      this.EditEnableIntensiveLogging = new CheckBoxOptions();
      this.EditEnableIntensiveLogging.Name = "EditEnableIntensiveLogging"
      this.EditEnableIntensiveLogging.LabelKey = "EnableIntensiveLogging"
      this.EditEnableIntensiveLogging.Value = this.Template.enableIntensiveLogging
  
  
      this.modalService.open(EditTemplateModal);
  
    });
    
 
   
  }
  editTemplate() {
    if (this.EditTemplateForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.EditTemplateForm.value;
      let TemplateModel = new TemplateDTO();
      TemplateModel.ID = Number(this.TemplateId);
      TemplateModel.Name.Arabic = ResultModel.Name.ArabicValue;
      TemplateModel.Name.English = ResultModel.Name.EnglishValue;
      TemplateModel.SysName = ResultModel.EditSysName
      TemplateModel.Description.English = ResultModel.EditDescriptionInEnglish
      TemplateModel.Description.Arabic = ResultModel.EditDescriptionInArabic
      TemplateModel.OrganizationID = Number(ResultModel.EditOrganization)
      TemplateModel.CategoryItemID = Number(ResultModel.EditCategory)
      TemplateModel.LanguageModeItemID = Number(ResultModel.EditLanguageMode)
      TemplateModel.EmailHeaderAndFooterTemplateID = Number(ResultModel.EditMasterLayout)
      TemplateModel.IsEmail = ResultModel.EditIsEmail
      TemplateModel.IsSms = ResultModel.EditIsSms
      TemplateModel.EnableIntensiveLogging = ResultModel.EditEnableIntensiveLogging

      this.templateService.EditEmailTemplate(TemplateModel).subscribe((result) => {
        this.modalService.dismissAll();
        }, (error) => {
      
        })
    }
  }

  showSendEmailModal(SendEmailModal) {
    this.utilityService.startBlockUI();
    this.SendEmailForm = new FormGroup({})

    this.To = new TextAreaOptions();
    this.To.Name = "To";
    this.To.LabelKey = "To";
    this.To.Value = null;
    this.To.IsRequired = true;


    this.EmailServiceProvider = new DropdownOptions();
    this.EmailServiceProvider.Name = "EmailServiceProvider"
    this.EmailServiceProvider.LabelKey = "EmailServiceProvider"
    this.EmailServiceProvider.DataSource = this.EmailServiceProviderList
    this.EmailServiceProvider.SingleSelection = true;
    this.EmailServiceProvider.AllowSearchFilter = true;
    this.EmailServiceProvider.Placeholder = "";
    this.EmailServiceProvider.IsRequired = true;

    this.Language = new DropdownOptions();
    this.Language.Name = "Language"
    this.Language.LabelKey = "Language"
    this.Language.DataSource = this.LanguageList
    this.Language.SingleSelection = true;
    this.Language.AllowSearchFilter = true;
    this.Language.Placeholder = "";
    this.Language.IsRequired = true;
    this.modalService.open(SendEmailModal);
    this.utilityService.stopBlockUI();

  }
  sendEmail() {
    if (this.SendEmailForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.SendEmailForm.value;
      let sendEmailTemplateModel = new SendEmailTemplateModel();
      sendEmailTemplateModel.TemplateID = Number(this.TemplateId);
      sendEmailTemplateModel.ToEmails = ResultModel.To
      sendEmailTemplateModel.LangKey = ResultModel.Language
      sendEmailTemplateModel.EmailProviderName = ResultModel.EmailServiceProvider
       this.templateService.SendEmailTemplate(sendEmailTemplateModel).subscribe((result) => {
         this.modalService.dismissAll();
        }, (error) => {
       })
    }
  }


  showTestSendEmailModal(TestSendEmailModal) {
    this.utilityService.startBlockUI();
    this.SendEmailForm = new FormGroup({})

    this.TestSendEmailTo = new TextAreaOptions();
    this.TestSendEmailTo.Name = "TestSendEmailTo";
    this.TestSendEmailTo.LabelKey = "SendTo";
    this.TestSendEmailTo.Value = null;
    this.TestSendEmailTo.IsRequired = true;

    this.TestEmailServiceProvider = new DropdownOptions();
    this.TestEmailServiceProvider.Name = "TestEmailServiceProvider"
    this.TestEmailServiceProvider.LabelKey = "EmailServiceProvider"
    this.TestEmailServiceProvider.DataSource = this.EmailServiceProviderList
    this.TestEmailServiceProvider.SingleSelection = true;
    this.TestEmailServiceProvider.AllowSearchFilter = true;
    this.TestEmailServiceProvider.Placeholder = "";
    this.TestEmailServiceProvider.IsRequired = true;
    this.modalService.open(TestSendEmailModal);
    this.utilityService.stopBlockUI();

  }
  testSendEmail() {
    if (this.TestSendEmailForm.invalid) {
      return;
    }
    else {
       let ResultModel = this.TestSendEmailForm.value;
      let sendEmailTemplateModel = new EmailTemplateTesterModel();
      sendEmailTemplateModel.TemplateID = Number(this.TemplateId);
      sendEmailTemplateModel.ToEmail = ResultModel.TestSendEmailTo
      sendEmailTemplateModel.EmailProviderName = ResultModel.TestEmailServiceProvider
       this.templateService.TestSendEmailTemplate(sendEmailTemplateModel).subscribe((result) => {
         this.modalService.dismissAll();
       }, (error) => {
        })
    }
  }

  showTestSendSMSModal(TestSendSMSModal) {
    this.utilityService.startBlockUI();
    this.SendEmailForm = new FormGroup({})

    this.TestSendSMSTo = new PhoneOptions();
    this.TestSendSMSTo.Name = "TestSendSMSTo";
    this.TestSendSMSTo.LabelKey = "SendTo";
    this.TestSendSMSTo.Value = null;
    this.TestSendSMSTo.IsRequired = true;
    this.TestSendSMSTo.ShowAsterisk = true;
    this.TestSendSMSTo.SelectedCountryISO = Country.UnitedArabEmirates
    this.TestSendSMSTo.PhoneValidation = true
    this.TestSendSMSTo.AllowSearch = true

    this.TestSMSServiceProvider = new DropdownOptions();
    this.TestSMSServiceProvider.Name = "TestSMSServiceProvider"
    this.TestSMSServiceProvider.LabelKey = "SMSServiceProvider"
    this.TestSMSServiceProvider.DataSource = this.SMSServiceProviderList
    this.TestSMSServiceProvider.SingleSelection = true;
    this.TestSMSServiceProvider.AllowSearchFilter = true;
    this.TestSMSServiceProvider.Placeholder = "";
    this.TestSMSServiceProvider.IsRequired = true;
    this.modalService.open(TestSendSMSModal);
    this.utilityService.stopBlockUI();

  }
  testSendSMS() {
    if (this.TestSendSMSForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.TestSendSMSForm.value;
      let sendSMSTemplateModel = new SMSTemplateTesterModel();
      sendSMSTemplateModel.TemplateID = Number(this.TemplateId);
      let internationalNumber: string = null;
      if (ResultModel.TestSendSMSTo != null) {
        internationalNumber = ResultModel.TestSendSMSTo.internationalNumber as string;
        internationalNumber = internationalNumber.replace(/\s/g, "");
      }
      sendSMSTemplateModel.ToMobileNumber = internationalNumber
      sendSMSTemplateModel.SMSProviderName = ResultModel.TestSMSServiceProvider
       this.templateService.TestSMSTemplate(sendSMSTemplateModel).subscribe((result) => {
         this.modalService.dismissAll();
       }, (error) => {
        })
    }
  }
}
